import { Avatar } from '@seek/avatar';
import type { Locale } from '@seek/melways-sites';
import {
  Box,
  Stack,
  Columns,
  Column,
  Accordion,
  AccordionItem,
  Text,
} from 'braid-design-system';
import { type FC, useState } from 'react';

import HtmlContent from '../PreviousApplications/Details/HtmlContent';

import EmailItemMeta from './EmailItemMeta';

interface Props {
  id: string;
  from: string;
  subject: string;
  message: string;
  isNew: boolean;
  markAsNotNew: () => void;
  locale: Locale;
  dateSent: string;
}

export const ProspectEmailListItem: FC<Props> = ({
  from,
  id,
  message,
  subject,
  locale,
  isNew,
  dateSent,
  markAsNotNew,
}: Props) => {
  const [expanded, setExpanded] = useState(false);

  const removeHTMLTags = () => {
    const doc = new DOMParser().parseFromString(message, 'text/html');
    return doc.body.textContent || '';
  };

  const updateToggleOpen = () => {
    setExpanded((prev) => !prev);
  };

  return (
    <Box
      data-testid="email-item"
      onClick={() => {
        updateToggleOpen(); // Toggles the AccordionItem
      }}
      cursor="pointer"
    >
      <Stack space="small">
        <Columns space="xsmall">
          <Column width="content">
            <Avatar variant="initials" name={from} size="xsmall" />
          </Column>
          <Column>
            <EmailItemMeta
              locale={locale}
              from={from}
              isNew={isNew}
              markAsNotNew={markAsNotNew}
              dateSent={dateSent}
            />

            <Accordion size="small" dividers={false}>
              <AccordionItem
                label={subject}
                id={id}
                onToggle={() => {}}
                expanded={expanded}
              >
                <HtmlContent
                  content={message}
                  size="small"
                  space="xsmall"
                  isSecondary={false}
                />
              </AccordionItem>
            </Accordion>

            {!expanded && (
              <Box paddingTop="small">
                <Text maxLines={1} size="small">
                  {removeHTMLTags()}
                </Text>
              </Box>
            )}
          </Column>
        </Columns>
      </Stack>
    </Box>
  );
};
